// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"UniflowCalculator_tooltip__34yeb","tooltipText":"UniflowCalculator_tooltipText__zqhYs"};